import axios from 'axios'
import APIConfig from '../remote/APIConfig.js'

export default class PostTagService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/post-tag'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/post-tag', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/post-tag/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/post-tag/${id}`)
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  calcuateUsedTimes (articleTagList, articleList) {
    var tagIDUsedTimes = {}
    var i
    var id
    for (i = articleList.length - 1; i >= 0; --i) {
      let tagIDArr = articleList[i].Tags.map(o => o.ID)

      for (id of tagIDArr) {
        if (!tagIDUsedTimes[id]) tagIDUsedTimes[id] = 0
        ++tagIDUsedTimes[id]
      }
    }
    let tagIDArr = Object.keys(tagIDUsedTimes)
    for (i = tagIDArr.length - 1; i >= 0; --i) {
      let tagID = tagIDArr[i]
      let usedTimes = tagIDUsedTimes[tagID]
      let articleTag = (articleTagList.find(o => o.ID === tagID) || {})
      articleTag.usedTimes = usedTimes
    }
  }
  findCommonlyUsedList (articleTagList) {
    const N = 15
    // 找出前n個常用標籤 的數字
    let sortedUsedTimesArr = articleTagList.map(o => o.usedTimes || 0).sort((o1, o2) => o2 - o1)
    let minUsedTimes = sortedUsedTimesArr[Math.min(sortedUsedTimesArr.length, N) - 1]
    // 找出常用標籤並排序
    let commonlyUsedTagList = articleTagList
      .filter(o => (o.usedTimes || 0) >= minUsedTimes)
      .sort((o1, o2) => (o2.usedTimes || 0) - (o1.usedTimes || 0))
    return commonlyUsedTagList
  }
}
